import { useCustomMediaQuery } from '@libs/hooks/useCustomMediaQuery';

export type SettingsDevice = 'desktop' | 'mobile';

export const SETTINGS_MEDIA_QUERIES: Record<SettingsDevice, string> = {
  desktop: '(min-width: 690px)',
  mobile: '(max-width: 689px)',
};

export function useSettingsMQ() {
  const device: SettingsDevice = useCustomMediaQuery(SETTINGS_MEDIA_QUERIES, 'desktop');

  return {
    device,
    isDesktop: device === 'desktop',
    isMobile: device === 'mobile',
  };
}
